import React from 'react';
export function TickCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 2H12a10 10 0 00-.016 20H12a10 10 0 10.014-20zm5.633 15.666A7.945 7.945 0 0112 20h-.012A8 8 0 0112 4h.01a8 8 0 015.637 13.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.475 9.172l-3.536 3.535-1.414-1.414a1 1 0 00-1.414 1.414l2.121 2.121a1 1 0 001.414 0l4.243-4.242a1 1 0 00-1.414-1.414z"
  }));
}